import { useObserver } from "mobx-react";
import {
  AiOutlineCloseCircle,
} from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { useStores } from "../../../store";

export default function Alerts() {
  const { PopupStore } = useStores();
  const navigate = useNavigate();
  const closeThisPopUP = () => {
    PopupStore.setAlert(false);
  };
  return useObserver(() => {
    return (
      <>
        {PopupStore.alert && (
          <div
            onClick={() => closeThisPopUP}
            className="fixed w-screen h-screen z-40 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40"
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="absolute  inset-0 bg-bg3 z-50 flex flex-col justify-center rounded-xl items-center md:w-[35%] lg:w-[25%] w-[90%] h-fit m-auto shadow-lg overflow-y-auto no-scrollbar"
            >
              <div className="flex flex-col gap-6 justify-between items-start p-6  h-full py-5 w-[100%] md:w-[100%] lg:[100%] border ">
                <span className=" text-primary rounded-full flex items- justify-between">
                  <AiOutlineCloseCircle
                    className="w-5 h-5 cursor-pointer absolute text-xl  top-2 right-2"
                    onClick={closeThisPopUP}
                  />
                </span>
                <div
                  className="flex flex-col justify-start items-center w-full py-1 gap-1 h-full "
                  style={{
                    scrollbarWidth: "none",
                  }}
                >
                  <div className="text-2xl flex justify-start items-center w-full gap-4">
                    {PopupStore.alertIcon}

                    <div className="flex flex-col">
                      <span className="text-sm md:text-xl text-primary font-semibold">
                        {PopupStore.alertTitle}
                      </span>
                      <span className="text-sm md:text-lg pl-0  ">
                        {PopupStore.alertMessage}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="w-full flex justify-end gap-5">
                  {/* <OutlineButton
                  padding={'0px'}
                    buttonName={"Close"}
                    onClick={closeThisPopUP}
                  /> */}

                  <div className="flex justify-end">
                    {PopupStore.alertButton}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  });
}
